<template>
	<div class="admin-breadcrumbs">
		<span class="breadcrumb">Administrator</span>
		<span class="breadcrumb">
			<span>&gt;</span>
			<span><router-link :to="{ name: 'AdminDashboard' }">Dashboard</router-link></span>
		</span>
		<span v-for="breadcrumb in breadcrumbs" :key="breadcrumb.title" class="breadcrumb">
			<span>&gt;</span>
			<span v-if="breadcrumb.name"><router-link :to="{ name: breadcrumb.name }">{{ breadcrumb.title }}</router-link></span>
			<span v-else>{{ breadcrumb.title }}</span>
		</span>
		<!--pre>{{ breadcrumbs }}</pre-->
	</div>
</template>

<script>
export default {
	props: {
		breadcrumbs: {
			type: Array,
			default: () => []
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminBreadcrumbs.vue